<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<!-- 교정이력정보 -->
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!-- 교정이력정보 -->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001359') }}</span>
				</div>
			</div>

			<sf-data-table
				ref="dataTable"
				:pageUnit="hisPagingInfo1.pageUnit"
				:totalSize="hisPagingInfo1.totalSize"
				paging
				:columns="columns"
				:rows="rows"
				:excel="isButton_(scrId, 'EX')"
				height="28vh"
				index
			>
			</sf-data-table>

			<!-- 이상신청 이력정보 -->
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!-- 이상신청 이력정보 -->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001360') }}</span>
				</div>
			</div>

			<sf-data-table
				ref="dataTable"
				:pageUnit="hisPagingInfo2.pageUnit"
				:totalSize="hisPagingInfo2.totalSize"
				paging
				:columns="columns2"
				:rows="rows2"
				:excel="isButton_(scrId, 'EX')"
				height="28vh"
				index
			>
			</sf-data-table>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/mmc/mmcm/MesInfo/store/helpers';

export default {
	props: { scrId: { type: String, default: '' } },
	created() {
		// this.pprNo = this.mainKey;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.hisResultList1;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001346'), //교정일(완료)
					prop: 'calCmplDd',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001325'), //교정방식
					prop: 'calWayCd',
					minWidth: '80px',
					form: {
						type: 'select',
						options: this.calWayCdList,
						placeholder: ' ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001323'), //교정주기
					prop: 'calCyclCd',
					minWidth: '70px',
					form: {
						type: 'select',
						options: this.calCyclCdList,
						placeholder: ' ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001324'), //차기교정일
					prop: 'nextCalDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptNm',
					minWidth: '80px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001340'), //사용장소
					prop: 'usePlCd',
					minWidth: '100px',
					form: {
						type: 'select',
						options: this.usePlCdList,
						placeholder: ' ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Nm',
					minWidth: '70px'
				},
				{
					label: this.getMessage_('QWCC001361'), //입고일시
					prop: 'whsnDt',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('QWCC001362'), //교정기관
					prop: 'calInstCd',
					minWidth: '90px',
					form: {
						type: 'select',
						options: this.calInstCdList,
						placeholder: ' ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001348'), //성적서번호
					prop: 'rslrNo',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001345'), //교정결과
					prop: 'calRsltCd',
					minWidth: '70px',
					form: {
						type: 'select',
						options: this.calRsltCdList,
						placeholder: ' ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001347'), //교정비용
					prop: 'calExp',
					minWidth: '70px'
				},
				{
					label: this.getMessage_('QWCC000906'), //비고
					prop: 'rmk',
					minWidth: '300px'
				}
			];
		},
		rows2() {
			return this.hisResultList2;
		},
		columns2() {
			return [
				{
					label: this.getMessage_('QWCC000979'), // 신청일
					prop: 'apcnDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('MWCC000104'), // 신청자명
					prop: 'aplcNm',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001251'), //신청자 ID
					prop: 'aplcId',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001253'), //신청부서
					prop: 'apcnDeptNm',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '100px',
					sortable: false,
					form: {
						type: 'select',
						options: this.runStCdList,
						placeholder: ' ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC000906'), // 비고
					prop: 'rmk',
					minWidth: '500px',
					sortable: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	}
};
</script>

<style></style>
